import { useState, useMemo, useRef, useEffect } from "react";
import { useApiCall } from "../../../component/custom-hooks/api-call";
import moment from "moment";
import InnerLoader from "../../../component/ui/loader/inner-loader";
import { Alert, Snackbar } from "@mui/material";
import { MetricCard } from "../../../component/new-ui/cards";
import { pkr, usd } from "../../../component/custom-hooks/capitalizeWords";
import { FileUploadProgressBar } from "../../../component/form/form-layout";
import DataNotFound from "../../../component/ui/loader/data-not-found";

// const FX_RATE = 279.2;
const TODAY_DAY = 5;
const CUR_MONTH = "March";
const CUR_YEAR = 2026;

// const LOC_COLORS = { Ittehad: "#4f6ef7", "Phase 8": "#7c5ce0", "Phase 8 II": "#14b8a6", Remote: "#f97316" };
// const LOC_EMOJI = { Ittehad: "🏢", "Phase 8": "🏢", "Phase 8 II": "🏗", Remote: "🌐" };
// const CAT_ICONS = { Rent: "🏠", Electricity: "⚡", Internet: "📡", Generator: "🔋", Maintenance: "🔧", Security: "🔒", Groceries: "💧", Repairs: "🛠", "Bank Charges": "🏦", Salaries: "👥", Miscellaneous: "💳" };
const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
// const LOCS = ["Ittehad", "Phase 8", "Phase 8 II", "Remote"];
// const CATS = Object.keys(CAT_ICONS);

const INITIAL_BILLS = [
    { id: 1, month: "January", expense: "Expert Cool (AC Service)", vendor: "Expert Cool", cat: "Maintenance", loc: "Ittehad", amt: 28000, dueDay: null, method: "Cash", status: "Overdue", paidDate: null, ref: "", chequeGroup: null, attachments: [], notes: "Overdue from Jan" },
    { id: 2, month: "January", expense: "Daisy Tech Repairs", vendor: "Daisy Tech", cat: "Repairs", loc: "Ittehad", amt: 89050, dueDay: null, method: "Cash", status: "Overdue", paidDate: null, ref: "", chequeGroup: null, attachments: [], notes: "Overdue from Jan" },
    { id: 3, month: "January", expense: "Generator — Ittehad", vendor: "Generator Vendor", cat: "Generator", loc: "Ittehad", amt: 55000, dueDay: 10, method: "Cheque", status: "Overdue", paidDate: null, ref: "", chequeGroup: null, attachments: [], notes: "" },
    { id: 4, month: "January", expense: "Security — Phase 8", vendor: "Security Co.", cat: "Security", loc: "Phase 8", amt: 32000, dueDay: 1, method: "Cheque", status: "Overdue", paidDate: null, ref: "", chequeGroup: null, attachments: [], notes: "" },
    { id: 5, month: "January", expense: "Security — Ittehad", vendor: "Security Co.", cat: "Security", loc: "Ittehad", amt: 32000, dueDay: 1, method: "Cheque", status: "Overdue", paidDate: null, ref: "", chequeGroup: null, attachments: [], notes: "" },
    { id: 6, month: "January", expense: "Aquafina — Ittehad", vendor: "Aquafina", cat: "Groceries", loc: "Ittehad", amt: 6840, dueDay: 10, method: "Cash", status: "Overdue", paidDate: null, ref: "", chequeGroup: null, attachments: [], notes: "" },
    { id: 7, month: "March", expense: "Rent — Ittehad", vendor: "Landlord", cat: "Rent", loc: "Ittehad", amt: 329450, dueDay: 1, method: "Cheque", status: "Overdue", paidDate: null, ref: "", chequeGroup: null, attachments: [], notes: "" },
    { id: 8, month: "March", expense: "Rent — Phase 8", vendor: "Landlord", cat: "Rent", loc: "Phase 8", amt: 65000, dueDay: 1, method: "Cheque", status: "Overdue", paidDate: null, ref: "", chequeGroup: null, attachments: [], notes: "" },
    { id: 9, month: "March", expense: "Rent — Remote", vendor: "Landlord", cat: "Rent", loc: "Remote", amt: 55000, dueDay: 1, method: "Cheque", status: "Overdue", paidDate: null, ref: "", chequeGroup: null, attachments: [], notes: "" },
    { id: 10, month: "March", expense: "Rent — Phase 8 II", vendor: "Landlord", cat: "Rent", loc: "Phase 8 II", amt: 65000, dueDay: 1, method: "Cheque", status: "Overdue", paidDate: null, ref: "", chequeGroup: null, attachments: [], notes: "" },
    { id: 11, month: "March", expense: "Security — Ittehad", vendor: "Security Co.", cat: "Security", loc: "Ittehad", amt: 32500, dueDay: 1, method: "Cheque", status: "Overdue", paidDate: null, ref: "", chequeGroup: null, attachments: [], notes: "" },
    { id: 12, month: "March", expense: "Security — Phase 8", vendor: "Security Co.", cat: "Security", loc: "Phase 8", amt: 32500, dueDay: 1, method: "Cheque", status: "Overdue", paidDate: null, ref: "", chequeGroup: null, attachments: [], notes: "" },
    { id: 13, month: "March", expense: "Maintenance — Ittehad", vendor: "Building Mgmt", cat: "Maintenance", loc: "Ittehad", amt: 34000, dueDay: 5, method: "Cash", status: "Due", paidDate: null, ref: "", chequeGroup: null, attachments: [], notes: "" },
    { id: 14, month: "March", expense: "Maintenance — Phase 8", vendor: "Building Mgmt", cat: "Maintenance", loc: "Phase 8", amt: 6500, dueDay: 5, method: "Cash", status: "Due", paidDate: null, ref: "", chequeGroup: null, attachments: [], notes: "" },
    { id: 15, month: "March", expense: "Maintenance — Remote", vendor: "Building Mgmt", cat: "Maintenance", loc: "Remote", amt: 6500, dueDay: 5, method: "Cash", status: "Due", paidDate: null, ref: "", chequeGroup: null, attachments: [], notes: "" },
    { id: 16, month: "March", expense: "Maintenance — Phase 8 II", vendor: "Building Mgmt", cat: "Maintenance", loc: "Phase 8 II", amt: 8000, dueDay: 5, method: "Cheque", status: "Due", paidDate: null, ref: "", chequeGroup: null, attachments: [], notes: "" },
    { id: 17, month: "March", expense: "Aquafina — Ittehad", vendor: "Aquafina", cat: "Groceries", loc: "Ittehad", amt: 6840, dueDay: 10, method: "Cash", status: "Due", paidDate: null, ref: "", chequeGroup: null, attachments: [], notes: "" },
    { id: 18, month: "March", expense: "Generator — Ittehad", vendor: "Generator Vendor", cat: "Generator", loc: "Ittehad", amt: 55000, dueDay: 10, method: "Cheque", status: "Due", paidDate: null, ref: "", chequeGroup: null, attachments: [], notes: "" },
    { id: 19, month: "March", expense: "Generator — Phase 8", vendor: "Generator Vendor", cat: "Generator", loc: "Phase 8", amt: 35000, dueDay: 10, method: "Cheque", status: "Due", paidDate: null, ref: "", chequeGroup: null, attachments: [], notes: "Shared w/ Remote" },
    { id: 20, month: "March", expense: "Internet — Stormfiber", vendor: "Stormfiber", cat: "Internet", loc: "Ittehad", amt: 20062, dueDay: 15, method: "Cheque", status: "Due", paidDate: null, ref: "", chequeGroup: null, attachments: [], notes: "" },
    { id: 21, month: "March", expense: "Internet — Cybernet", vendor: "Cybernet", cat: "Internet", loc: "Ittehad", amt: 23064, dueDay: 15, method: "Cheque", status: "Due", paidDate: null, ref: "", chequeGroup: null, attachments: [], notes: "" },
    { id: 22, month: "March", expense: "Internet — Optix (Ittehad)", vendor: "Optix", cat: "Internet", loc: "Ittehad", amt: 9598, dueDay: 15, method: "Cheque", status: "Due", paidDate: null, ref: "", chequeGroup: null, attachments: [], notes: "" },
    { id: 23, month: "March", expense: "Internet — Transworld (P8)", vendor: "Transworld", cat: "Internet", loc: "Phase 8", amt: 14633, dueDay: 15, method: "Cheque", status: "Due", paidDate: null, ref: "", chequeGroup: null, attachments: [], notes: "" },
    { id: 24, month: "March", expense: "Internet — Optix (Remote)", vendor: "Optix", cat: "Internet", loc: "Remote", amt: 32021, dueDay: 15, method: "Cheque", status: "Due", paidDate: null, ref: "", chequeGroup: null, attachments: [], notes: "" },
    { id: 25, month: "March", expense: "Internet — Transworld (R)", vendor: "Transworld", cat: "Internet", loc: "Remote", amt: 27382, dueDay: 15, method: "Cheque", status: "Due", paidDate: null, ref: "", chequeGroup: null, attachments: [], notes: "" },
    { id: 26, month: "March", expense: "Electricity — Ittehad", vendor: "K-Electric", cat: "Electricity", loc: "Ittehad", amt: 200000, dueDay: null, method: "Cheque", status: "Due", paidDate: null, ref: "", chequeGroup: null, attachments: [], notes: "On bill receipt" },
    { id: 27, month: "March", expense: "Electricity — Phase 8", vendor: "K-Electric", cat: "Electricity", loc: "Phase 8", amt: 100000, dueDay: null, method: "Cheque", status: "Due", paidDate: null, ref: "", chequeGroup: null, attachments: [], notes: "On bill receipt" },
    { id: 28, month: "March", expense: "Electricity — Remote", vendor: "K-Electric", cat: "Electricity", loc: "Remote", amt: 120000, dueDay: null, method: "Cheque", status: "Due", paidDate: null, ref: "", chequeGroup: null, attachments: [], notes: "On bill receipt" },
];


const ord = d => { if (!d) return null; const s = ["th", "st", "nd", "rd"], v = d % 100; return d + (s[(v - 20) % 10] || s[v] || s[0]); };

function deriveStatus(b) {
    if (b.status === "Paid") return "Paid";
    if (b.month !== CUR_MONTH) return "Overdue";
    if (b.dueDay && b.dueDay < TODAY_DAY) return "Overdue";
    return "Due";
}

function SBadge({ s }) {
    const m = { Paid: { bg: "#f0fdf4", c: "#16a34a", bd: "#bbf7d0", icon: "✓" }, Overdue: { bg: "#fef2f2", c: "#dc2626", bd: "#fecaca", icon: "⚠" }, Due: { bg: "#fffbeb", c: "#d97706", bd: "#fde68a", icon: "○" } };
    const t = m[s] || m.Due;
    return <span style={{ display: "inline-flex", alignItems: "center", gap: 4, padding: "3px 9px", borderRadius: 20, background: t.bg, border: `1px solid ${t.bd}`, fontSize: 11, fontWeight: 700, color: t.c, whiteSpace: "nowrap" }}>{t.icon} {s}</span>;
}

function DDBadge({ dueDay, month, status }) {
    // console.log("TODAY_DAY", TODAY_DAY)
    const dueDate = moment(dueDay, "DD-MMM-YYYY").format("DD")
    if (!dueDay) return <span style={{ fontSize: 11, color: "#9ca3af", fontStyle: "italic" }}>On receipt</span>;
    const late = month !== CUR_MONTH || dueDate < moment(new Date()).format("DD");
    const today = month === CUR_MONTH && dueDate === moment(new Date()).format("DD");
    const soon = month === CUR_MONTH && dueDate > moment(new Date()).format("DD") && dueDate <= moment(new Date()).format("DD") + 5;
    // const bg = late || today ? "#fef2f2" : soon ? "#fffbeb" : "#f0f9ff";
    const bg = status == "Paid" ? "#f0f9ff" : status == "Overdue" ? "fef2f2" : "#fffbeb";
    // const bd = late || today ? "#fecaca" : soon ? "#fde68a" : "#bae6fd";
    const bd = status == "Paid" ? "#bae6fd" : status == "Overdue" ? "fecaca" : "#fde68a";
    // const c = late || today ? "#dc2626" : soon ? "#d97706" : "#0369a1";
    const c = status == "Paid" ? "#0369a1" : status == "Overdue" ? "dc2626" : "#d97706";

    return <span style={{ display: "inline-flex", alignItems: "center", gap: 3, padding: "3px 9px", borderRadius: 20, background: bg, border: `1px solid ${bd}`, fontSize: 11, fontWeight: 600, color: c, whiteSpace: "nowrap" }}>
        📅 {ord(dueDate)}{today ? " · Today" : late ? " ⚠" : soon ? " ⚡" : ""}
    </span>;
}

// ─── STATUS GROUP ─────────────────────────────────────────────────────────────
function StatusGroup({ title, color, bg, borderColor, usd, bills, total, locations, onPay, onBatchPay, selected, onToggle, C, expanded, onToggleExpand, LOC_COLORS }) {
    const unpaid = bills.filter(b => b.status !== "Paid");
    const selInGroup = bills.filter(b => selected.has(b.id));

    let totalPkr = 0;

    for (let i = 0; i < bills?.length; i++) {
        totalPkr += Number(bills[i]?.amount)
    }

    return (
        <div style={{ borderRadius: 14, border: `1px solid ${borderColor}`, overflow: "hidden", boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
            {/* Group header */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 20px", background: bg, cursor: "pointer" }} onClick={onToggleExpand}>
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                    <span style={{ width: 9, height: 9, borderRadius: "50%", background: color, flexShrink: 0, boxShadow: color !== "transparent" ? `0 0 0 3px ${borderColor}` : "none" }} />
                    <span style={{ fontSize: 13, fontWeight: 800, color, letterSpacing: -0.2 }}>{title}</span>
                    <span style={{ fontSize: 12, padding: "2px 9px", borderRadius: 20, background: color + "20", border: `1px solid ${borderColor}`, color, fontWeight: 700 }}>{bills.length}</span>
                    {selInGroup.length > 0 && (
                        <span style={{ fontSize: 11, padding: "2px 9px", borderRadius: 20, background: "#ede9fe", border: "1px solid #c4b5fd", color: "#7c3aed", fontWeight: 600 }}>
                            {selInGroup.length} selected
                        </span>
                    )}
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                    {unpaid.length > 1 && (
                        <button onClick={e => { e.stopPropagation(); onBatchPay(unpaid); }}
                            style={{ display: "flex", alignItems: "center", gap: 5, padding: "6px 14px", borderRadius: 8, background: "#16a34a", border: "none", fontSize: 11, fontWeight: 700, color: "#fff", cursor: "pointer", boxShadow: "0 1px 6px rgba(22,163,74,0.25)" }}>
                            ✓ Pay all {unpaid.length}
                        </button>
                    )}
                    <div style={{ textAlign: "right" }}>
                        <div style={{ fontSize: 15, fontWeight: 800, color, }}>{pkr(totalPkr)}</div>
                        <div style={{ fontSize: 11, color: color, opacity: 0.7 }}>{usd(totalPkr)}</div>
                    </div>
                    <span style={{ fontSize: 14, color, opacity: 0.6 }}>{expanded ? "▲" : "▼"}</span>
                </div>
            </div>

            {/* Bills */}
            {expanded && (
                <div style={{ background: "#fff" }}>
                    {/* Column headers */}
                    <div style={{
                        display: "grid", gridTemplateColumns: "36px 28px 1.8fr 90px 110px 130px 120px 110px 88px",
                        gap: 0,
                        padding: "0 16px",
                        background: "#f9f8f7",
                        borderBottom: "1px solid rgba(0,0,0,0.06)",
                        borderLeft: `3px solid transparent`,
                    }}>
                        {["", "", "Expense", "Month", "Office", "Due Date", "Amount", "Status", ""].map((h, i) => (
                            <div
                                key={i}
                                style={{
                                    padding: "10px 10px", fontSize: 14,
                                    fontWeight: 600, color: "#000",
                                    textTransform: "capitalize",
                                    borderRight: i < 8 ? `1px solid ${C.border}` : "none"
                                }}
                            >
                                {h}
                            </div>
                        ))}
                    </div>

                    {bills?.length === 0 ? (
                        <DataNotFound title={`${title} Bill`} />
                    ) : (
                        bills?.map((b, i) => {
                            const isPaid = b.status === "Paid";
                            const isOver = b.status === "Overdue";
                            const isToday = b.status === "Due" && b.due_date === moment(new Date()).format("DD-MMM-YYYY");
                            const locColor = locations.find(l => l.name === b.location?.name)?.color || C.accent;
                            const isSel = selected.has(b.id);
    
                            return (
                                <div key={b.id} style={{
                                    display: "grid", gridTemplateColumns: "36px 28px 1.8fr 90px 110px 130px 120px 110px 88px",
                                    gap: 0, padding: "0 16px",
                                    background: isSel ? "#ede9fe" : isPaid ? "#fafffe" : isToday ? "#fffef5" : i % 2 === 0 ? "#fff" : "#fafaf9",
                                    borderBottom: "1px solid rgba(0,0,0,0.05)",
                                    borderLeft: `3px solid ${isPaid ? "#86efac" : isOver ? C.red : isToday ? C.amber : "transparent"}`,
                                    transition: "background 0.1s",
                                }}>
                                    {/* Checkbox */}
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", borderRight: "1px solid rgba(0,0,0,0.05)" }}>
                                        {!isPaid && <input type="checkbox" checked={isSel} onChange={() => onToggle(b.id)} style={{ width: 14, height: 14, cursor: "pointer" }} />}
                                    </div>
                                    {/* Icon */}
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", borderRight: "1px solid rgba(0,0,0,0.05)", fontSize: 14 }}>
                                        {locations.find(l => l.name === b.category?.name)?.icon || "💳"}
                                    </div>
                                    {/* Expense + details */}
                                    <div style={{ padding: "11px 12px", borderRight: "1px solid rgba(0,0,0,0.05)", display: "flex", flexDirection: "column", justifyContent: "center", minWidth: 0 }}>
                                        <div style={{ fontSize: 12.5, fontWeight: 600, color: isPaid ? "#9ca3af" : "#111827", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{b.expense_name}</div>
                                        <div style={{ fontSize: 10.5, color: "#9ca3af", marginTop: 1, display: "flex", gap: 6, alignItems: "center", flexWrap: "wrap" }}>
                                            <span>{b.vendor}</span>
                                            {b.notes && <span style={{ fontStyle: "italic" }}>· {b.notes}</span>}
                                            {b.cheque_group && <span style={{ padding: "1px 6px", borderRadius: 20, background: "#ede9fe", border: "1px solid #c4b5fd", color: "#7c3aed", fontSize: 9, fontWeight: 700 }}>📝 Combined cheque</span>}
                                        </div>
                                        {isPaid && (
                                            <div style={{ fontSize: 10, color: "#16a34a", marginTop: 2, display: "flex", gap: 6, alignItems: "center" }}>
                                                <span>✓ Paid {b.paid_date}</span>
                                                {b.reference && <span>· {b.reference}</span>}
                                                {b.attachments?.length > 0 && <span>· 📎 {b.attachments.length} file{b.attachments.length > 1 ? "s" : ""}</span>}
                                            </div>
                                        )}
                                    </div>
                                    {/* Month */}
                                    <div style={{ padding: "11px 10px", borderRight: "1px solid rgba(0,0,0,0.05)", display: "flex", alignItems: "center" }}>
                                        <span style={{ fontSize: 11, color: b.bill_month !== CUR_MONTH ? "#dc2626" : "#6b7280", fontWeight: b.bill_month !== CUR_MONTH ? 700 : 400 }}>{b.bill_month}</span>
                                    </div>
                                    {/* Location */}
                                    <div style={{ padding: "11px 10px", borderRight: "1px solid rgba(0,0,0,0.05)", display: "flex", alignItems: "center" }}>
                                        <span style={{ display: "inline-flex", alignItems: "center", gap: 4, padding: "2px 8px", borderRadius: 20, background: `${locColor}15`, border: `1px solid ${locColor}30`, fontSize: 10, fontWeight: 700, color: locColor }}>
                                            {locations.find(l => l.name === b.location?.name)?.emoji} {b.location?.name}
                                        </span>
                                    </div>
                                    {/* Due date */}
                                    <div style={{ padding: "11px 10px", borderRight: "1px solid rgba(0,0,0,0.05)", display: "flex", alignItems: "center" }}>
                                        <DDBadge dueDay={b.due_date} month={b.bill_month} status={b?.status} />
                                    </div>
                                    {/* Amount */}
                                    <div style={{ padding: "11px 10px", borderRight: "1px solid rgba(0,0,0,0.05)", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "flex-end" }}>
                                        <span style={{ fontSize: 13, fontWeight: 800, color: isPaid ? "#16a34a" : isOver ? "#dc2626" : "#111827", }}>{pkr(Number(b?.amount))}</span>
                                        <span style={{ fontSize: 10, color: "#9ca3af", marginTop: 1 }}>{usd(Number(b?.amount))}</span>
                                    </div>
                                    {/* Status */}
                                    <div style={{ padding: "11px 10px", borderRight: "1px solid rgba(0,0,0,0.05)", display: "flex", alignItems: "center" }}>
                                        <SBadge s={b.status} />
                                    </div>
                                    {/* Action */}
                                    <div style={{ padding: "8px 10px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                        {!isPaid
                                            ? <button onClick={() => onPay([b])}
                                                style={{ padding: "5px 12px", borderRadius: 8, border: "none", background: "#16a34a", fontSize: 11, fontWeight: 700, color: "#fff", cursor: "pointer", whiteSpace: "nowrap", boxShadow: "0 1px 4px rgba(22,163,74,0.2)" }}>
                                                Pay ✓
                                            </button>
                                            : <span style={{ fontSize: 11, color: "#16a34a", fontWeight: 600 }}>✓ Done</span>
                                        }
                                    </div>
                                </div>
                            );
                        })
                    )}


                    {/* Group footer */}
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "11px 20px", background: "#f9fafb", borderTop: "1px solid rgba(0,0,0,0.06)" }}>
                        <span style={{ fontSize: 11, color: "#6b7280" }}>{bills.filter(b => b.status === "Paid").length} of {bills.length} paid</span>
                        <div style={{ display: "flex", gap: 10, alignItems: "baseline" }}>
                            <span style={{ fontSize: 14, fontWeight: 800, color, }}>{pkr(totalPkr)}</span>
                            <span style={{ fontSize: 11, color: "#9ca3af" }}>{usd(totalPkr)}</span>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

// ─── MAIN ─────────────────────────────────────────────────────────────────────
export default function BillsAll() {
    const apiCall = useApiCall();
    const [apiData, setApiData] = useState({});
    const [isLoading, setIsLoading] = useState(true)
    const [bills, setBills] = useState(INITIAL_BILLS);
    const [payModal, setPayModal] = useState(null);
    const [addModal, setAddModal] = useState(false);
    const [addForm, setAddForm] = useState({});
    const [selected, setSelected] = useState(new Set());
    const [filterLoc, setFilterLoc] = useState("All");
    const [filterCat, setFilterCat] = useState("All");
    const [filterMonth, setFilterMonth] = useState("All");
    const [search, setSearch] = useState("");
    const [expanded, setExpanded] = useState({ Overdue: true, Due: true, Paid: false });
    const [years, setYears] = useState([]);
    const [categories, setCategories] = useState([]);
    const [locations, setLocations] = useState([]);
    const [fxRate, setFxRate] = useState(0);


    // ─── PAY MODAL ────────────────────────────────────────────────────────────────
    function PayModal({ bills, onClose, C }) {
        const isBatch = bills.length > 1;
        const hasCheque = bills.some(b => b.payment_method === "Cheque");
        const hasCash = bills.some(b => b.payment_method === "Cash");
        const mixed = hasCheque && hasCash;
        const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
        // const [combineRef, setCombineRef] = useState(""); // single combined cheque#
        // const [rows, setRows] = useState(bills.map(b => ({ id: b.id, method: b.payment_method, ref: "" })));
        // const [useCombined, setUseCombined] = useState(hasCheque && !mixed);
        // const updateRow = (id, field, val) => setRows(p => p.map(r => r.id === id ? { ...r, [field]: val } : r));
        const [files, setFiles] = useState('');
        const [refrence, setRefrence] = useState("")
        const totalAmt = bills.reduce((s, b) => s + Number(b.amount), 0);
        const lbl = { fontSize: 11, fontWeight: 600, color: "#9ca3af", letterSpacing: 0.5, textTransform: "uppercase", marginBottom: 5, display: "block" };
        const inp = (x = {}) => ({ padding: "8px 11px", borderRadius: 8, border: "1px solid rgba(0,0,0,0.08)", background: "#f9f8f7", fontSize: 12, color: "#111827", outline: "none", width: "100%", boxSizing: "border-box", ...x });
        const [notes, setNotes] = useState("");

        const payBill = async () => {
            let payData = {}
            if (isBatch) {
                payData = {
                    ids: bills?.map((b) => b.id),
                    paid_date: date,
                    use_combined: true,
                    combined_ref: refrence,
                    cheque_group: "paid",
                    attachment: files
                }
            } else {
                payData = {
                    id: bills[0]?.id,
                    paid_date: date,
                    reference: refrence,
                    notes: notes,
                    attachment: files
                }
            }
            try {
                const apiRes = await apiCall({ method: "post", url: isBatch ? "cash-flow/bills/batch-pay" : "cash-flow/bills/mark-paid", data: payData })
                onSuccess(apiRes?.respMsg || apiRes?.responseMessage || apiRes?.message || `Bill Paid`)
                setIsLoading(true)
                onClose()
            } catch (error) {
                console.log("Err", error)
                onError(error?.respMsg || error?.responseMessage || error?.message || `Some Thing Went Wrong`)
            }
        }

        return (
            <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 300, display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }} onClick={onClose}>
                <div style={{ background: "#fff", borderRadius: 18, boxShadow: "0 8px 48px rgba(0,0,0,0.2)", width: "100%", maxWidth: isBatch ? 600 : 460, maxHeight: "92vh", overflow: "auto" }} onClick={e => e.stopPropagation()}>

                    {/* Header */}
                    <div style={{ padding: "20px 24px", borderBottom: "1px solid rgba(0,0,0,0.08)" }}>
                        <h2 style={{ margin: 0, fontSize: 17, fontWeight: 800, color: "#111827", }}>
                            {isBatch ? `Pay ${bills.length} Bills` : "Mark as Paid"}
                        </h2>
                        <p style={{ margin: "4px 0 0", fontSize: 12, color: "#6b7280" }}>
                            {isBatch
                                ? `Total: ${pkr(totalAmt, false)} · ${usd(totalAmt, false)}`
                                : `${bills[0].expense_name} · ${bills[0].location?.name} · ${pkr(Number(bills[0].amount))}`
                            }
                        </p>
                    </div>

                    <div style={{ padding: "22px 24px" }}>

                        {/* Bill summary (batch) */}
                        {isBatch && (
                            <div style={{ marginBottom: 20 }}>
                                <div style={{ background: "#f9fafb", borderRadius: 10, border: "1px solid rgba(0,0,0,0.08)", overflow: "hidden" }}>
                                    {bills.map((b, i) => (
                                        <div key={b.id} style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 14px", borderBottom: i < bills.length - 1 ? "1px solid rgba(0,0,0,0.05)" : "none" }}>
                                            <span style={{ fontSize: 14, flexShrink: 0 }}>{locations.find(l => l.name === b.category?.name)?.icon || "💳"}</span>
                                            <div style={{ flex: 1, minWidth: 0 }}>
                                                <div style={{ fontSize: 12, fontWeight: 600, color: "#111827", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{b.expense_name}</div>
                                                <div style={{ fontSize: 10, color: "#9ca3af", marginTop: 1, display: "flex", gap: 6, alignItems: "center" }}>
                                                    {/* background: `${LOC_COLORS[b.location?.name]}18`, color: LOC_COLORS[b.location?.name], */}
                                                    <span style={{ padding: "1px 6px", borderRadius: 20, background: `${locations.find(l => l.name === b?.location?.name)?.color || "#9ca3af"}18`, color: locations.find(l => l.name === b?.location?.name)?.color || "#9ca3af", fontSize: 9, fontWeight: 700 }}>{b.location?.name}</span>
                                                    <span style={{ padding: "3px 7px", borderRadius: 20, background: "#f3f4f6", border: "1px solid rgba(0,0,0,0.08)", fontSize: 10, fontWeight: 500, color: "#6b7280" }}>
                                                        {b.payment_method === "Cheque" ? "📝 Cheque" : b.payment_method === "Cash" ? "💵 Cash" : "🏦 Transfer"}
                                                    </span>
                                                </div>
                                            </div>
                                            <div style={{ textAlign: "right", flexShrink: 0 }}>
                                                <div style={{ fontSize: 13, fontWeight: 800, color: "#111827" }}>{pkr(Number(b.amount))}</div>
                                                <div style={{ fontSize: 10, color: "#9ca3af" }}>{usd(Number(b.amount))}</div>
                                            </div>
                                        </div>
                                    ))}
                                    {/* Total row */}
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 14px", background: "#f0fdf4", borderTop: "1px solid #bbf7d0" }}>
                                        <span style={{ fontSize: 12, fontWeight: 700, color: "#166534" }}>Total</span>
                                        <div style={{ display: "flex", gap: 10, alignItems: "baseline" }}>
                                            <span style={{ fontSize: 15, fontWeight: 800, color: "#16a34a", }}>{pkr(totalAmt)}</span>
                                            <span style={{ fontSize: 12, color: "#166534" }}>{usd(totalAmt)}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Payment date */}
                        <div style={{ marginBottom: 16 }}>
                            <label style={lbl}>Payment Date</label>
                            <input type="date" value={date} onChange={e => setDate(e.target.value)} style={inp()} />
                        </div>

                        {/* Cheque reference — context-aware */}
                        {hasCheque && (
                            <div style={{ marginBottom: 16 }}>
                                {mixed ? (
                                    // Mixed — cash + cheque: show method toggle per bill
                                    <div>
                                        <label style={lbl}>Payment References</label>
                                        <div style={{ fontSize: 11, color: "#d97706", background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 8, padding: "8px 12px", marginBottom: 10 }}>
                                            ⚡ Mixed session — some cash, some cheque. Add cheque # where applicable.
                                        </div>
                                        <div>
                                            <label style={lbl}>Cheque # / Reference</label>
                                            <input value={refrence || ""} onChange={e => setRefrence(e.target.value)}
                                                placeholder="e.g. 88242395" style={inp()} />
                                        </div>
                                    </div>
                                ) : isBatch && hasCheque && !mixed ? (
                                    <div>
                                        <label style={lbl}>Cheque # / Reference</label>
                                        <input value={refrence || ""} onChange={e => setRefrence(e.target.value)}
                                            placeholder="e.g. 88242395" style={inp()} />
                                    </div>
                                ) : (
                                    // Single cheque
                                    <div>
                                        <label style={lbl}>Cheque # / Reference</label>
                                        <input value={refrence || ""} onChange={e => setRefrence(e.target.value)}
                                            placeholder="e.g. 88242395" style={inp()} />
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Receipt upload */}
                        <div style={{ marginBottom: 22 }}>
                            <label style={lbl}>Receipt / Invoice {isBatch ? "(covers all bills)" : ""}</label>
                            <FileUploadProgressBar onChange={e => setFiles(e)} />
                            {/* <input type="file" ref={fileRef} multiple accept="image/*,.pdf" style={{ display: "none" }} onChange={e => setFiles(prev => [...prev, ...Array.from(e.target.files)])} />
                            <div style={{ border: "2px dashed rgba(0,0,0,0.1)", borderRadius: 10, padding: "16px", background: "#f9fafb", cursor: "pointer", textAlign: "center" }} onClick={() => fileRef.current.click()}>
                                {files.length === 0 ? (
                                    <div>
                                        <div style={{ fontSize: 22, marginBottom: 6 }}>📎</div>
                                        <div style={{ fontSize: 12, color: "#6b7280", fontWeight: 500 }}>Click to upload receipt or invoice</div>
                                        <div style={{ fontSize: 10, color: "#9ca3af", marginTop: 3 }}>PDF, JPG, PNG supported</div>
                                    </div>
                                ) : (
                                    <div>
                                        {files.map((f, i) => (
                                            <div key={i} style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "4px 10px", borderRadius: 20, background: "#ede9fe", border: "1px solid #c4b5fd", fontSize: 11, color: "#7c3aed", fontWeight: 500, margin: "2px" }}>
                                                📎 {f.name}
                                                <span onClick={e => { e.stopPropagation(); setFiles(p => p.filter((_, j) => j !== i)); }} style={{ cursor: "pointer", color: "#9ca3af", marginLeft: 2 }}>✕</span>
                                            </div>
                                        ))}
                                        <div style={{ fontSize: 10, color: "#9ca3af", marginTop: 6, cursor: "pointer" }}>+ Add more files</div>
                                    </div>
                                )}
                            </div> */}
                        </div>

                        <div className="" style={{ marginBottom: 16 }}>
                            <div>
                                <label style={lbl}>Notes</label>
                                <textarea value={notes || ""} className="h-[80px]" onChange={e => setNotes(e.target.value)} style={inp()} />
                            </div>
                        </div>

                        {/* Confirm */}

                        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, paddingTop: 14, borderTop: "1px solid rgba(0,0,0,0.08)" }}>
                            <button onClick={onClose} style={{ padding: "9px 20px", borderRadius: 9, border: "1px solid rgba(0,0,0,0.08)", background: "#f9f8f7", fontSize: 13, fontWeight: 600, color: "#6b7280", cursor: "pointer" }}>Cancel</button>
                            {/* <button onClick={() => onConfirm({
                                ids: bills.map(b => b.id),
                                date,
                                refMap: useCombined
                                    ? Object.fromEntries(bills.map(b => [b.id, combineRef]))
                                    : Object.fromEntries(rows.map(r => [r.id, r.ref || combineRef])),
                                files,
                            })}
                                style={{ padding: "9px 24px", borderRadius: 9, border: "none", background: "#16a34a", fontSize: 13, fontWeight: 700, color: "#fff", cursor: "pointer", boxShadow: "0 2px 8px rgba(22,163,74,0.3)" }}>
                                ✓ Confirm Payment
                            </button> */}
                            <button onClick={payBill} style={{ padding: "9px 24px", borderRadius: 9, border: "none", background: "#16a34a", fontSize: 13, fontWeight: 700, color: "#fff", cursor: "pointer", boxShadow: "0 2px 8px rgba(22,163,74,0.3)" }}>
                                ✓ Confirm Payment
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const C = {
        navBg: "#1e2128", pageBg: "#EDE8E1", cardBg: "#ffffff",
        accent: "#4f6ef7", green: "#16a34a", red: "#dc2626", amber: "#d97706",
        textPri: "#111827", textSec: "#6b7280", textMut: "#9ca3af",
        border: "rgba(0,0,0,0.08)", shadow: "0 1px 3px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.08)",
    };
    const card = (x = {}) => ({ background: C.cardBg, borderRadius: 14, border: `1px solid ${C.border}`, boxShadow: C.shadow, ...x });

    const enriched = useMemo(() => [...apiData?.data?.due || [], ...apiData?.data?.overdue || [], ...apiData?.data?.paid || []]?.map(b => ({ ...b, ds: deriveStatus(b) })), [apiData]);

    const filtered = useMemo(() => enriched.filter(b => {
        if (filterLoc !== "All" && b.loc !== filterLoc) return false;
        if (filterCat !== "All" && b.cat !== filterCat) return false;
        if (filterMonth !== "All" && b.month !== filterMonth) return false;
        if (search && !b?.expense?.toLowerCase()?.includes(search.toLowerCase()) && !b?.vendor?.toLowerCase()?.includes(search?.toLowerCase())) return false;
        return true;
    }), [enriched, filterLoc, filterCat, filterMonth, search]);

    const overdue = filtered.filter(b => b.status === "Overdue");
    const due = filtered.filter(b => b.status === "Due");
    const paid = filtered.filter(b => b.status === "Paid");
    const overdueTotal = overdue.reduce((s, b) => s + b.amt, 0);
    const dueTotal = due.reduce((s, b) => s + b.amt, 0);
    const paidTotal = paid.reduce((s, b) => s + b.amt, 0);
    const cashNeed = overdueTotal + dueTotal;

    const [alertData, setAlertData] = useState({ isShow: false });

    const handleClose = () => {
        setAlertData({ isShow: false });
    };

    const onSuccess = (message) => {
        setAlertData({ isShow: true, type: "success", message: message });
        getData();
    };

    const onError = (message) => {
        setAlertData({ isShow: true, type: "error", message: message });
    };

    const confirmPay = ({ ids, date, refMap, files }) => {
        const groupRef = files.length > 0 || Object.values(refMap).some(r => r) ? (Object.values(refMap)[0] || "") : "";
        setBills(p => p.map(b => {
            if (!ids.includes(b.id)) return b;
            return { ...b, status: "Paid", paidDate: date, ref: refMap[b.id] || groupRef, chequeGroup: ids.length > 1 ? groupRef : null, attachments: [...b.attachments, ...files.map(f => f.name)] };
        }));
        setSelected(new Set());
        setPayModal(null);
    };
    const openAddModal = () => {
        setAddForm({ expense: "", cat: "", year: moment(new Date()).format("YYYY"), loc: "", amt: "", dueDay: "", method: "", month: CUR_MONTH, notes: "" });
        setAddModal(true);
    };
    const saveNewBill = async () => {
        if (!addForm.expense || !addForm.amt) return;

        const billData = {
            "expense_name": addForm?.expense,
            "category_id": addForm?.cat,
            "location_id": addForm?.loc,
            "amount": addForm.amt,
            "due_date": addForm?.dueDay,
            "payment_method": addForm?.method,
            "bill_month": addForm?.month,
            "bill_year": addForm?.year,
            "notes": addForm?.notes
        }

        try {
            const apiRes = await apiCall({ method: "post", url: "cash-flow/bills/add", data: billData })
            console.log(apiRes);
            setAddModal(false);
            setIsLoading(true);
            onSuccess(apiRes?.respMsg || apiRes?.responseMessage || apiRes?.message || `Add Bill`)
            // getData()
        } catch (error) {
            console.log("Err", error)
            onError(error?.respMsg || error?.responseMessage || error?.message || `Some Thing Went Wrong`)
        }

        // const newBill = {
        //     id: Date.now(),
        //     month: addForm.month || CUR_MONTH,
        //     expense: addForm.expense,
        //     vendor: addForm.vendor || addForm.expense,
        //     cat: addForm.cat || "Miscellaneous",
        //     loc: addForm.loc || "",
        //     amt: parseFloat(addForm.amt) || 0,
        //     dueDay: addForm.dueDay ? parseInt(addForm.dueDay) : null,
        //     method: addForm.method || "Cheque",
        //     status: "Due",
        //     paidDate: null,
        //     ref: "",
        //     chequeGroup: null,
        //     attachments: [],
        //     notes: addForm.notes || "",
        // };
        // setBills(p => [...p, newBill]);
        // setAddModal(false);
    };

    const getData = async () => {
        try {
            const apiRes = await apiCall({ method: "get", url: "cash-flow/bills/list" })
            setApiData(apiRes);
            setIsLoading(false)
        } catch (error) {
            console.log("Err", error)
        }
    }

    const fetchCategories = async () => {
        try {
            const res = await apiCall({ url: "cash-flow/categories/list", method: "GET" });
            setCategories(res.data || []);
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };

    const fetchLocations = async () => {
        try {
            const res = await apiCall({ url: "cash-flow/locations/list", method: "GET" });
            setLocations(res.data || []);
        } catch (error) {
            console.error("Error fetching locations:", error);
        }
    };

    const fetchFxRate = async () => {
        try {
            const res = await apiCall({ url: "cash-flow/fx-rates/latest", method: "GET" });
            setFxRate(parseFloat(res.data.rate) || 279.2);
        } catch (error) {
            console.error("Error fetching FX rate:", error);
            setFxRate(279.2); // fallback
        }
    };


    useEffect(() => {
        fetchCategories();
        fetchLocations();
        fetchFxRate();
    }, []);

    const [dropdowns, setDropdowns] = useState({})

    const getDropdowns = async () => {
        try {
            const apiRes = await apiCall({ method: "get", url: "cash-flow/dropdown" })
            setDropdowns(apiRes?.dropdown)
        } catch (error) {
            console.log("Err", error)
        }
    }

    useEffect(() => {
        getDropdowns()
        getData()
    }, [])

    const toggleSelect = id => setSelected(p => { const n = new Set(p); n.has(id) ? n.delete(id) : n.add(id); return n; });
    const selBills = enriched.filter(b => selected.has(b.id) && b.ds !== "Paid");

    useEffect(() => {
        let customYear = [];
        let currentYear = moment(new Date()).format("MM") == 12 ? moment(new Date()).format("YYYY") + 1 : moment(new Date()).format("YYYY");
        for (let i = 2018; i <= currentYear; i++) {
            customYear.push(i);
        }
        setYears(customYear);
    }, []);

    return (
        <div className="overflow-auto flex flex-col">

            {/* PAGE */}
            <div style={{ flex: 1, padding: "24px 0px", width: "100%", margin: "0 auto" }}>

                {/* Header */}
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 18 }}>
                    <div>
                        <h1 style={{ fontSize: 22, fontWeight: 800, color: C.textPri, letterSpacing: -0.5, margin: 0 }}>Bills</h1>
                        <p style={{ fontSize: 13, color: C.textSec, marginTop: 3 }}>{CUR_MONTH} {CUR_YEAR} · Today is the {ord(TODAY_DAY)}</p>
                    </div>
                    {selBills.length > 0 && (
                        <button onClick={() => setPayModal(selBills)}
                            style={{ display: "flex", alignItems: "center", gap: 8, padding: "9px 20px", borderRadius: 10, background: C.green, border: "none", fontSize: 13, fontWeight: 700, color: "#fff", cursor: "pointer", boxShadow: "0 2px 8px rgba(22,163,74,0.3)" }}>
                            ✓ Pay {selBills.length} Selected Bills — {pkr(selBills.reduce((s, b) => s + Number(b.amount), 0))}
                        </button>
                    )}
                    <button onClick={openAddModal}
                        style={{ display: "flex", alignItems: "center", gap: 6, padding: "9px 18px", borderRadius: 10, background: C.accent, border: "none", fontSize: 13, fontWeight: 700, color: "#fff", cursor: "pointer", boxShadow: "0 2px 8px rgba(79,110,247,0.3)" }}>
                        + Add Bill
                    </button>
                </div>

                {isLoading ?
                    <InnerLoader />
                    :
                    <>
                        {/* SUMMARY CARDS */}
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 14, marginBottom: 18 }}>
                            {[
                                {
                                    label: "Cash Needed",
                                    pkr: apiData?.stats?.cash_needed?.pkr,
                                    usd: apiData?.stats?.cash_needed?.dollor,
                                    count: apiData?.data?.overdue?.length + apiData?.data?.due?.length,
                                    bg: "#fff1f2",
                                    bd: "#fecaca",
                                    c: C.red,
                                    icon: "💸"
                                },
                                { label: "Overdue", pkr: apiData?.stats?.total_overdue?.pkr, usd: apiData?.stats?.total_overdue?.dollor, count: apiData?.data?.overdue?.length, bg: "#fef2f2", bd: "#fecaca", c: C.red, icon: "⚠️", onClick: () => setExpanded({ Overdue: true, Due: false, Paid: false }) },
                                { label: "Due", pkr: apiData?.stats?.total_due?.pkr, usd: apiData?.stats?.total_due?.dollor, count: apiData?.data?.due?.length, bg: "#fffbeb", bd: "#fde68a", c: C.amber, icon: "📋", onClick: () => setExpanded({ Overdue: false, Due: true, Paid: false }) },
                                { label: "Paid", pkr: apiData?.stats?.total_paid?.pkr, usd: apiData?.stats?.total_paid?.dollor, count: apiData?.data?.paid?.length, bg: "#f0fdf4", bd: "#bbf7d0", c: C.green, icon: "✅", onClick: () => setExpanded({ Overdue: false, Due: false, Paid: true }) },
                            ].map((s, i) => (
                                <MetricCard
                                    icon={<span>{s.icon}</span>}
                                    iconColor={s.c}
                                    iconBg={s.bg}
                                    valueColor={s.c}
                                    badge={{ text: `${s?.count}  bills`, type: 'neutral' }}
                                    value={pkr(s.pkr.replaceAll(",", ""))}
                                    statsBadge={usd(s.usd)}
                                    isBadge={true}
                                    label={s.label}
                                />
                            ))}
                        </div>

                        {/* FILTER BAR */}
                        <div style={{ ...card({ padding: "11px 16px", marginBottom: 16, display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }) }}>
                            <div style={{ position: "relative", flex: "1 1 160px" }}>
                                <span style={{ position: "absolute", left: 9, top: "50%", transform: "translateY(-50%)", fontSize: 12, color: C.textMut }}>🔍</span>
                                <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search expense or vendor…"
                                    style={{ padding: "6px 10px 6px 29px", borderRadius: 8, border: `1px solid ${C.border}`, background: "#f9f8f7", fontSize: 12, color: C.textPri, outline: "none", width: "100%", boxSizing: "border-box" }} />
                            </div>
                            {[
                                { val: filterLoc, set: setFilterLoc, opts: ["All Offices", ...locations.map(c => c.name)], key: "All" },
                                { val: filterMonth, set: setFilterMonth, opts: ["All Months", ...MONTHS], key: "All" },
                                { val: filterCat, set: setFilterCat, opts: ["All Categories", ...categories.map(c => c.name)], key: "All" },
                            ].map((f, i) => (
                                <select key={i} value={f.val} onChange={e => f.set(e.target.value === "All Offices" || e.target.value === "All Months" || e.target.value === "All Categories" ? "All" : e.target.value)}
                                    style={{ padding: "6px 10px", borderRadius: 8, border: `1px solid ${C.border}`, background: "#fff", fontSize: 11, color: C.textPri, cursor: "pointer", outline: "none" }}>
                                    {f.opts.map(o => <option key={o}>{o}</option>)}
                                </select>
                            ))}
                            {(search || filterLoc !== "All" || filterMonth !== "All" || filterCat !== "All") &&
                                <button onClick={() => { setSearch(""); setFilterLoc("All"); setFilterMonth("All"); setFilterCat("All"); }}
                                    style={{ padding: "5px 10px", borderRadius: 8, border: `1px solid ${C.border}`, background: "#fff", fontSize: 11, color: C.textSec, cursor: "pointer" }}>✕ Clear</button>
                            }
                            <span style={{ marginLeft: "auto", fontSize: 11, color: C.textMut }}>{filtered.length} bills</span>
                        </div>

                        {/* STATUS GROUPS — default view */}
                        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                            {[
                                { key: "Overdue", title: "Overdue", bills: apiData?.data?.overdue, total: apiData?.data?.overdue?.length, color: C.red, bg: "#fff8f8", border: "#fecaca" },
                                { key: "Due", title: "Due — March", bills: apiData?.data?.due, total: apiData?.data?.due?.length, color: C.amber, bg: "#fffdf5", border: "#fde68a" },
                                { key: "Paid", title: "Paid", bills: apiData?.data?.paid, total: apiData?.data?.paid?.length, color: C.green, bg: "#f8fffe", border: "#bbf7d0" },
                            ].map(group => (
                                <StatusGroup
                                    usd={usd}
                                    locations={locations}
                                    key={group.key}
                                    title={group.title}
                                    color={group.color}
                                    bg={group.bg}
                                    borderColor={group.border}
                                    bills={group.bills}
                                    total={group.total}
                                    onPay={b => setPayModal(b)}
                                    onBatchPay={b => setPayModal(b)}
                                    selected={selected}
                                    onToggle={toggleSelect}
                                    C={C}
                                    expanded={expanded[group.key]}
                                    onToggleExpand={() => setExpanded(p => ({ ...p, [group.key]: !p[group.key] }))}
                                />
                            ))}
                        </div>
                    </>
                }
            </div>

            {/* PAY MODAL */}
            {payModal && <PayModal bills={Array.isArray(payModal) ? payModal : payModal} onConfirm={confirmPay} onClose={() => setPayModal(null)} C={C} />}

            {/* ADD BILL MODAL */}
            {addModal && (
                <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 300, display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }} onClick={() => setAddModal(false)}>
                    <div style={{ background: "#fff", borderRadius: 18, boxShadow: "0 8px 48px rgba(0,0,0,0.2)", width: "100%", maxWidth: 480, maxHeight: "90vh", overflow: "auto" }} onClick={e => e.stopPropagation()}>
                        <div style={{ padding: "20px 24px", borderBottom: "1px solid rgba(0,0,0,0.08)" }}>
                            <h2 style={{ margin: 0, fontSize: 17, fontWeight: 800, color: "#111827", }}>Add One-Off Bill</h2>
                            <p style={{ margin: "4px 0 0", fontSize: 12, color: "#6b7280" }}>For non-recurring expenses — repairs, ad-hoc maintenance, etc.</p>
                        </div>
                        <div style={{ padding: "20px 24px" }}>
                            {/* Expense name */}
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 14 }}>
                                <div className="">
                                    <label style={{ fontSize: 11, fontWeight: 700, color: "#9ca3af", letterSpacing: 0.5, textTransform: "uppercase", display: "block", marginBottom: 5 }}>Expense Name *</label>
                                    <input value={addForm.expense || ""} onChange={e => setAddForm(p => ({ ...p, expense: e.target.value }))} placeholder="e.g. Daisy Tech Repairs — Ittehad"
                                        style={{ width: "100%", padding: "9px 11px", borderRadius: 8, border: "1px solid rgba(0,0,0,0.1)", fontSize: 13, outline: "none", boxSizing: "border-box" }} />
                                </div>
                                <div>
                                    <label style={{ fontSize: 11, fontWeight: 700, color: "#9ca3af", letterSpacing: 0.5, textTransform: "uppercase", display: "block", marginBottom: 5 }}>Amount (PKR) *</label>
                                    <input type="number" value={addForm.amt || ""} onChange={e => setAddForm(p => ({ ...p, amt: e.target.value }))} placeholder="e.g. 89050"
                                        style={{ width: "100%", padding: "9px 11px", borderRadius: 8, border: "1px solid rgba(0,0,0,0.1)", fontSize: 13, outline: "none", boxSizing: "border-box" }} />
                                </div>
                            </div>
                            {/* Amount + Month row */}
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 14 }}>

                                <div>
                                    <label style={{ fontSize: 11, fontWeight: 700, color: "#9ca3af", letterSpacing: 0.5, textTransform: "uppercase", display: "block", marginBottom: 5 }}>Month</label>
                                    <select value={addForm.month || ""} onChange={e => setAddForm(p => ({ ...p, month: e.target.value }))}
                                        style={{ width: "100%", padding: "9px 11px", borderRadius: 8, border: "1px solid rgba(0,0,0,0.1)", fontSize: 13, background: "#f9f8f7", outline: "none", boxSizing: "border-box" }}>
                                        {MONTHS.map(m => <option key={m} value={m}>{m}</option>)}
                                    </select>
                                </div>

                                <div>
                                    <label style={{ fontSize: 11, fontWeight: 700, color: "#9ca3af", letterSpacing: 0.5, textTransform: "uppercase", display: "block", marginBottom: 5 }}>Month</label>
                                    <select value={addForm.year || ""} onChange={e => setAddForm(p => ({ ...p, year: e.target.value }))}
                                        style={{ width: "100%", padding: "9px 11px", borderRadius: 8, border: "1px solid rgba(0,0,0,0.1)", fontSize: 13, background: "#f9f8f7", outline: "none", boxSizing: "border-box" }}>
                                        {years.map(m => <option key={m} value={m}>{m}</option>)}
                                    </select>
                                </div>
                            </div>

                            {/* <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 14 }}>
                                
                            </div> */}
                            {/* Category + Location row */}
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 14 }}>
                                <div>
                                    <label style={{ fontSize: 11, fontWeight: 700, color: "#9ca3af", letterSpacing: 0.5, textTransform: "uppercase", display: "block", marginBottom: 5 }}>Category</label>
                                    <select value={addForm.cat || ""} onChange={e => setAddForm(p => ({ ...p, cat: e.target.value }))}
                                        style={{ width: "100%", padding: "9px 11px", borderRadius: 8, border: "1px solid rgba(0,0,0,0.1)", fontSize: 13, background: "#f9f8f7", outline: "none", boxSizing: "border-box" }}>
                                        <option value="">— Select —</option>
                                        {dropdowns?.category?.map(c => <option key={c?.id} value={c?.id}>{c?.name}</option>)}
                                    </select>
                                </div>
                                <div>
                                    <label style={{ fontSize: 11, fontWeight: 700, color: "#9ca3af", letterSpacing: 0.5, textTransform: "uppercase", display: "block", marginBottom: 5 }}>Location</label>
                                    <select value={addForm.loc || ""} onChange={e => setAddForm(p => ({ ...p, loc: e.target.value }))}
                                        style={{ width: "100%", padding: "9px 11px", borderRadius: 8, border: "1px solid rgba(0,0,0,0.1)", fontSize: 13, background: "#f9f8f7", outline: "none", boxSizing: "border-box" }}>
                                        <option value="">— Select —</option>
                                        {dropdowns?.lcoation?.map(l => <option key={l?.id} value={l?.id}>{l?.name}</option>)}
                                    </select>
                                </div>
                            </div>
                            {/* Due day + Method row */}
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 14 }}>
                                <div>
                                    <label style={{ fontSize: 11, fontWeight: 700, color: "#9ca3af", letterSpacing: 0.5, textTransform: "uppercase", display: "block", marginBottom: 5 }}>Due Date <span style={{ fontWeight: 400, textTransform: "none" }}>(leave blank = on receipt)</span></label>
                                    <input type="date" min="1" max="31" value={addForm.dueDay || ""} onChange={e => setAddForm(p => ({ ...p, dueDay: e.target.value }))} placeholder="e.g. 15"
                                        style={{ width: "100%", padding: "9px 11px", borderRadius: 8, border: "1px solid rgba(0,0,0,0.1)", fontSize: 13, outline: "none", boxSizing: "border-box" }} />
                                </div>
                                <div>
                                    <label style={{ fontSize: 11, fontWeight: 700, color: "#9ca3af", letterSpacing: 0.5, textTransform: "uppercase", display: "block", marginBottom: 5 }}>Payment Method</label>
                                    <select value={addForm.method || ""} onChange={e => setAddForm(p => ({ ...p, method: e.target.value }))}
                                        style={{ width: "100%", padding: "9px 11px", borderRadius: 8, border: "1px solid rgba(0,0,0,0.1)", fontSize: 13, background: "#f9f8f7", outline: "none", boxSizing: "border-box" }}>
                                        <option value="">— Select —</option>
                                        {dropdowns?.method?.map(m => <option key={m?.id} value={m?.name}>{m?.name}</option>)}
                                    </select>
                                </div>
                            </div>
                            {/* Notes */}
                            <div style={{ marginBottom: 20 }}>
                                <label style={{ fontSize: 11, fontWeight: 700, color: "#9ca3af", letterSpacing: 0.5, textTransform: "uppercase", display: "block", marginBottom: 5 }}>Notes <span style={{ fontWeight: 400, textTransform: "none" }}>(optional)</span></label>
                                <input value={addForm.notes || ""} onChange={e => setAddForm(p => ({ ...p, notes: e.target.value }))} placeholder="Any context…"
                                    style={{ width: "100%", padding: "9px 11px", borderRadius: 8, border: "1px solid rgba(0,0,0,0.1)", fontSize: 13, outline: "none", boxSizing: "border-box" }} />
                            </div>
                            <div style={{ display: "flex", gap: 8 }}>
                                <button onClick={() => setAddModal(false)}
                                    style={{ flex: 1, padding: "10px", borderRadius: 9, border: "1px solid rgba(0,0,0,0.1)", background: "#fff", fontSize: 13, cursor: "pointer", color: "#6b7280" }}>Cancel</button>
                                <button onClick={saveNewBill} disabled={!addForm.expense || !addForm.amt}
                                    style={{ flex: 2, padding: "10px", borderRadius: 9, border: "none", background: (!addForm.expense || !addForm.amt) ? "#9ca3af" : C.accent, fontSize: 13, fontWeight: 700, color: "#fff", cursor: (!addForm.expense || !addForm.amt) ? "not-allowed" : "pointer" }}>
                                    Add to Bills
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <Snackbar
                open={alertData?.isShow}
                autoHideDuration={3000}
                onClose={handleClose}
            >
                <Alert
                    onClose={handleClose}
                    severity={alertData?.type}
                    variant="filled"
                    sx={{ width: "100%" }}
                >
                    {alertData?.message}
                </Alert>
            </Snackbar>
        </div>
    );
}